// screens/AccountPausedScreen.tsx
//
// W6 v1.1 Session 2 — student-side "Account in pausa" landing.
// Shown when any student-app API call returns 423 Locked. Italian "tu" voice.
// No client-side unpause — only the instructor can clear the pause flag.

import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Screen } from '../components/Screen';
import { useTokens } from '../state/theme';
import { ProfMark } from '../components/ProfAvatar';

export default function AccountPausedScreen(): JSX.Element {
  const tokens = useTokens();
  const navigate = useNavigate();

  // W6 v1.1 review fix — paused students still need to find contact info
  // (Profilo) and read prior instructor messages (Messaggi). Pre-fix the
  // screen had no in-app navigation, leaving paused users at a UX dead-end.
  const primaryButton: React.CSSProperties = {
    minHeight: 44,
    padding: '12px 20px',
    background: tokens.surface,
    color: tokens.text,
    border: `1px solid ${tokens.line}`,
    borderRadius: tokens.radius.pill,
    fontFamily: tokens.fonts.body,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
  };

  return (
    <Screen>
      <div
        data-testid="account-paused-screen"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '32px 24px',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 14,
            background: tokens.accentSoft,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 16,
          }}
        >
          <ProfMark size={28} />
        </div>
        <h1
          style={{
            fontFamily: tokens.fonts.serif,
            fontSize: 26,
            fontWeight: 700,
            color: tokens.text,
            margin: '0 0 12px 0',
            letterSpacing: -0.5,
          }}
        >
          Il tuo account è in pausa
        </h1>
        <p
          style={{
            fontFamily: tokens.fonts.body,
            fontSize: 15,
            color: tokens.textMuted,
            margin: '0 0 18px 0',
            lineHeight: 1.5,
            maxWidth: 360,
          }}
        >
          Contatta il tuo istruttore per riprendere lo studio. Quando l'account verrà riattivato, potrai tornare qui senza fare nulla.
        </p>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            width: '100%',
            maxWidth: 280,
          }}
        >
          <button
            type="button"
            data-testid="account-paused-go-profilo"
            onClick={() => navigate('/profilo')}
            style={primaryButton}
          >
            Vai al profilo
          </button>
          <button
            type="button"
            data-testid="account-paused-go-messaggi"
            onClick={() => navigate('/messaggi')}
            style={primaryButton}
          >
            Apri i messaggi
          </button>
        </div>
      </div>
    </Screen>
  );
}
